export const formikFilterTextFieldMessages = {
  en: {
    invalidFilter: 'Invalid filter',
    valueMustBeNumber: 'Value must be number',
    valueRequired: 'Value is required',
  },
};
